module.exports = __webpack_public_path__ + "static/img/9.8b9152a4.jpg";